var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "2274.119 129.581 25.022 22.259",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeOpacity: 0.51,
      stroke: "rgb(6, 2, 57)",
      fill: "rgb(0, 25, 94)"
    },
    d: "M 2295.424 136.452 C 2295.424 138.178 2292.306 146.083 2290.108 146.083 L 2283.152 146.083 C 2280.953 146.083 2277.836 138.178 2277.836 136.452 L 2277.836 134.071 C 2277.836 132.383 2279.755 131.116 2281.953 129.581 L 2291.427 129.581 C 2293.624 131.116 2295.424 132.383 2295.424 134.071 L 2295.424 136.452 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)",
      fill: "rgb(12, 70, 177)"
    },
    d: "M 2290.228 146.083 L 2283.152 146.083 C 2280.953 146.083 2277.836 138.178 2277.836 136.452 L 2277.836 134.071 C 2277.836 132.383 2279.755 131.116 2281.953 129.581 L 2291.427 129.581"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(4, 99, 170)",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    d: "M 2299.141 151.84 C 2298.382 148.001 2293.064 148.77 2286.63 148.77 C 2280.195 148.77 2274.878 148.001 2274.119 151.84 L 2299.141 151.84 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)",
      fill: "rgb(57, 133, 233)"
    },
    d: "M 2283.152 146.083 C 2280.754 146.083 2277.836 138.178 2277.836 136.452 L 2277.836 134.071 C 2277.836 132.383 2279.755 131.116 2281.953 129.581"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(50, 206, 179)",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    d: "M 2290.267 147.618 C 2290.267 148.079 2290.267 148.386 2289.787 148.386 L 2283.472 148.386 C 2282.993 148.386 2282.993 148.079 2282.993 147.618 C 2282.993 147.158 2283.392 146.852 2283.872 146.852 L 2289.388 146.852 C 2289.867 146.852 2290.267 147.158 2290.267 147.618 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(37, 173, 183)",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    d: "M 2290.267 147.618 C 2290.267 148.079 2290.267 148.386 2289.787 148.386 L 2283.472 148.386 C 2282.993 148.386 2282.993 148.079 2282.993 147.618"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.049965, 0, 0, 0.047971, 2274.118232, 128.69849)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: "17.4552px",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)",
      fill: "rgb(0, 89, 157)"
    },
    d: "M160.8,149.6c0-24,40-84.8,89.6-84.8s89.6,61.6,89.6,84.8c0,24-40,23.2-89.6,23.2 C200.8,173.6,160.8,173.6,160.8,149.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: "17.4552px",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)",
      fill: "rgb(0, 89, 157)"
    },
    d: "M162.4,447.2c0,8-8,11.2-19.2,11.2h-16.8c-11.2,0-63.2-6.4-63.2-14.4l40.8-54.4 c0-8,11.2-11.2,22.4-11.2h16.8c11.2,0,19.2,4,19.2,12V447.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(7, 69, 137)",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    d: "M 2279.275 147.388 C 2279.275 147.005 2279.834 146.852 2280.394 146.852 L 2281.233 146.852 C 2281.794 146.852 2282.192 147.043 2282.192 147.427 L 2282.192 150.152 C 2282.192 150.536 2281.794 150.688 2281.233 150.688 L 2280.235 150.688"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(4, 99, 170)",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    d: "M 2291.026 150.152 C 2291.026 150.536 2291.346 150.688 2291.906 150.688 L 2292.745 150.688 C 2293.305 150.688 2295.784 150.458 2295.784 150.075 L 2293.784 147.427 C 2293.784 147.043 2293.305 146.852 2292.745 146.852 L 2291.906 146.852 C 2291.346 146.852 2291.026 147.043 2291.026 147.427 L 2291.026 150.152 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(7, 69, 137)",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    d: "M 2293.784 147.427 C 2293.784 147.043 2293.305 146.852 2292.745 146.852 L 2291.906 146.852 C 2291.346 146.852 2291.026 147.043 2291.026 147.427 L 2291.026 150.152 C 2291.026 150.536 2291.346 150.688 2291.906 150.688 L 2292.625 150.688"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(91, 244, 208)",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    d: "M 2285.15 138.216 C 2285.15 138.332 2285.23 138.408 2285.352 138.408 L 2287.909 138.408 C 2288.028 138.408 2288.109 138.332 2288.109 138.216 C 2288.109 138.101 2288.028 138.025 2287.909 138.025 L 2285.352 138.025 C 2285.23 138.025 2285.15 138.101 2285.15 138.216 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.049965, 0, 0, 0.047971, 2274.118232, 128.69849)",
    style: {}
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(50, 206, 179)",
      strokeWidth: "17.4552px",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    cx: 297.6,
    cy: 66.4,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(50, 206, 179)",
      strokeWidth: "17.4552px",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    cx: 266.4,
    cy: 66.4,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(50, 206, 179)",
      strokeWidth: "17.4552px",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    cx: 234.4,
    cy: 66.4,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(50, 206, 179)",
      strokeWidth: "17.4552px",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    cx: 203.2,
    cy: 66.4,
    r: 6.4
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(91, 244, 208)",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    d: "M 2282.153 135.03 C 2282.153 133.881 2284.151 132.959 2286.63 132.959 C 2289.108 132.959 2291.107 133.881 2291.107 135.03 C 2291.107 136.182 2289.108 136.143 2286.63 136.143 C 2284.151 136.143 2282.153 136.143 2282.153 135.03 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)",
      fill: "rgb(20, 140, 120)"
    },
    d: "M 2282.153 135.03 C 2282.153 133.881 2284.151 132.959 2286.63 132.959 C 2289.108 132.959 2291.107 133.881 2291.107 135.03"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(31, 144, 147)",
      strokeWidth: "17.4552px",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    cx: 250.4,
    cy: 122.4,
    r: 25.6,
    transform: "matrix(0.049965, 0, 0, 0.047971, 2274.118232, 128.69849)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(22, 117, 124)",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    d: "M 2286.63 133.304 C 2287.349 133.304 2287.909 133.881 2287.909 134.532 C 2287.909 135.185 2287.309 135.759 2286.63 135.759"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.049965, 0, 0, 0.047971, 2274.55329, 129.153461)",
    style: {}
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(252, 224, 224)",
      strokeWidth: "17.4552px",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    cx: 240.8,
    cy: 112,
    r: 10.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(252, 224, 224)",
      strokeWidth: "17.4552px",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    cx: 265.6,
    cy: 130.4,
    r: 3.2
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(7, 69, 137)",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    d: "M 2282.632 144.433 L 2282.632 145.892 C 2282.632 146.007 2282.952 146.045 2283.152 146.045 L 2290.067 146.045 C 2290.267 146.045 2290.587 146.007 2290.587 145.892 L 2290.587 144.433 L 2286.63 142.168 L 2282.632 144.433 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(4, 99, 170)",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    d: "M 2286.67 142.168 L 2282.632 144.433 L 2282.632 145.892 C 2282.632 146.007 2282.952 146.045 2283.152 146.045 L 2290.067 146.045 C 2290.267 146.045 2290.467 146.045 2290.587 145.93"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(7, 69, 137)",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    d: "M 2274.878 150.304 C 2274.517 150.688 2274.279 151.456 2274.119 151.84 L 2299.141 151.84 C 2299.021 151.456 2298.742 150.688 2298.382 150.304 L 2274.878 150.304 Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "rgb(45, 165, 232)",
      strokeOpacity: 0.51,
      stroke: "rgb(8, 0, 95)"
    },
    points: "2286.67 142.168 2282.632 144.433 2282.632 145.93"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.b1e792691ea09d730759b19dc8f8280f.svg";
export { ForwardRef as ReactComponent };